(() => {
  const cleanPolicyContent = (content) => {
    content.querySelectorAll('p, li').forEach((element) => {
      const hasMedia = element.querySelector('img, iframe, video, table');
      const hasText = element.textContent.replace(/\u00a0/g, ' ').trim().length > 0;

      if (!hasText && !hasMedia) {
        element.remove();
      }
    });

    content.querySelectorAll('ul, ol').forEach((list) => {
      const hasItems = list.querySelector('li');
      const hasText = list.textContent.replace(/\u00a0/g, ' ').trim().length > 0;

      if (!hasItems && !hasText) {
        list.remove();
      }
    });
  };

  const buildPolicyNavigation = (scope = document) => {
    const policyPages = scope.matches && scope.matches('[data-policy-page]')
      ? [scope]
      : Array.from(scope.querySelectorAll('[data-policy-page]'));

    policyPages.forEach((policyPage) => {
      const content = policyPage.querySelector('[data-policy-content]');
      const toc = policyPage.querySelector('[data-policy-toc]');

      if (!content || !toc) return;

      cleanPolicyContent(content);

      const headings = Array.from(content.querySelectorAll('h1, h2, h3')).filter((heading) => {
        return heading.textContent.trim().length > 0;
      });

      if (!headings.length) {
        return;
      }

      const usedIds = new Set();
      const fragment = document.createDocumentFragment();

      headings.forEach((heading, index) => {
        const headingText = heading.textContent.replace(/\s+/g, ' ').trim();
        let uniqueSlug = heading.id;

        if (!uniqueSlug) {
          let slug = headingText
            .toLowerCase()
            .replace(/&/g, ' and ')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');

          if (!slug) slug = `policy-section-${index + 1}`;

          uniqueSlug = slug;
          let duplicateIndex = 2;
          while (usedIds.has(uniqueSlug) || document.getElementById(uniqueSlug)) {
            uniqueSlug = `${slug}-${duplicateIndex}`;
            duplicateIndex += 1;
          }

          heading.id = uniqueSlug;
        }

        usedIds.add(uniqueSlug);

        const link = document.createElement('a');
        link.className = 'policy-page__toc-link';
        link.href = `#${uniqueSlug}`;
        link.textContent = headingText;
        fragment.appendChild(link);
      });

      toc.innerHTML = '';
      toc.appendChild(fragment);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => buildPolicyNavigation());
  } else {
    buildPolicyNavigation();
  }

  document.addEventListener('shopify:section:load', (event) => buildPolicyNavigation(event.target));
})();
